const loginConfigData = {
  msal: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri: "/",
    authority: process.env.REACT_APP_AUTHORITY,
    scopes: ["openid", "profile", "user.read"],
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export default loginConfigData;
